import { defineStore } from "pinia";

export const usePersonal = defineStore('personal', {
    state: () => {
      return {
        collectionPageNum: 1,  
        worksPageNum: 1,  
        fansPageNum: 1,  
        followPageNum: 1, 
        type:1,
      }
    },
    getters:{},
    actions: {
    }
  })